import { useState } from 'react';

const useSearchState = (defaults) => {
    const [searchText, setSearchText] = useState(defaults || '');

    const resetState = () => setSearchText('');

    const setText = (text) => {
        setSearchText(text);
    };

    const api = {
        resetState,
        setText,
        defaults
    };
    return { searchText, ...api };
};

export default useSearchState;
